import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from '@gympass/yoga'

import { Plus } from '@assets/icons'

import CollapsiblePanel from '@components/CollapsiblePanel'

import useFrequentQuestion from './FrequentQuestions.state'

import Container from '../../Home.style'
import * as Style from './FrequentQuestions.style'

export default function Companies() {
  const [isOpen, setIsOpen] = useState(false)
  const questions = useFrequentQuestion()

  const handlePanel = () => setIsOpen(!isOpen)

  return (
    <Style.Wrapper>
      <Container>
        <Row>
          <Col xxs={12} xl-start={2} xl={10}>
            <Style.TitleWrapper onClick={handlePanel}>
              <Style.Title>
                <FormattedMessage
                  id="smb_acquisition_faq.title"
                  values={{
                    span: (...chunks) => <span>{chunks}</span>,
                  }}
                />
              </Style.Title>
              <Style.Icon
                src={Plus}
                alt="show frequently asked questions"
                isOpen={isOpen}
              />
            </Style.TitleWrapper>

            {isOpen && (
              <Style.QuestionsWrapper>
                {questions.map(question => (
                  <CollapsiblePanel key={question.id} title={question.title}>
                    <Style.QuestionDescription
                      dangerouslySetInnerHTML={{ __html: question.description }}
                    />
                  </CollapsiblePanel>
                ))}
              </Style.QuestionsWrapper>
            )}
          </Col>
        </Row>
      </Container>
    </Style.Wrapper>
  )
}
